export default "/_next/static/images/signin-1-aff9321d4e4baad10b5d7162ecd6e575.png";